import { render } from "./ExternalVmsSidebar.vue?vue&type=template&id=d272793a&ts=true"
import script from "./ExternalVmsSidebar.vue?vue&type=script&lang=ts"
export * from "./ExternalVmsSidebar.vue?vue&type=script&lang=ts"

import "./ExternalVmsSidebar.vue?vue&type=style&index=0&id=d272793a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__